/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SystemInputs */

const en_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const es_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const fr_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Système`)
};

const de_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const ja_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム`)
};

const zh_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统`)
};

const ar_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النظام`)
};

const id_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistem`)
};

const it_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const ru_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Система`)
};

const pt_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const ko_system = /** @type {(inputs: SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시스템`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {SystemInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const system = /** @type {((inputs?: SystemInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SystemInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_system(inputs)
	if (locale === "es") return es_system(inputs)
	if (locale === "fr") return fr_system(inputs)
	if (locale === "de") return de_system(inputs)
	if (locale === "ja") return ja_system(inputs)
	if (locale === "zh") return zh_system(inputs)
	if (locale === "ar") return ar_system(inputs)
	if (locale === "id") return id_system(inputs)
	if (locale === "it") return it_system(inputs)
	if (locale === "ru") return ru_system(inputs)
	if (locale === "pt") return pt_system(inputs)
	return ko_system(inputs)
});